@for (part of (titleParts$ | async); track part.type) {
    @switch (part.type)  {
        @case (partTypeText) {
            <span class="title-part">
                {{$any(part.data).translate ? ($any(part.data).text | l10n) : $any(part.data).text}}
            </span>
        }
        @case (partTypeSymbol) {
            <w-header-title-part-symbol
                [data]="$any(part.data)"
                [widget]="widget"
                class="title-part">
            </w-header-title-part-symbol>
        }
        @case (partTypeGroupShared) {
            <w-header-title-part-group-shared
                [data]="$any(part.data)"
                [widget]="widget"
                class="title-part">
            </w-header-title-part-group-shared>
        }
    }
}
